<script>
import SortableTable from "@components/SortableTable.vue";
import api from "@services/api";

export default {
  extends: SortableTable,
  components: {},
  props: {
    fields: {
      type: Array,
      default: () => {
        return [
          { name: "deStr", description: "De" },
          { name: "paraStr", description: "Para" }
        ];
      }
    },
    filter: {
      type: String,
      default: ""
    },
    include: {
      type: String,
      default: ""
    },
    CategoriaDeParaId: {
      type: Number,
      default: -1
    },
    showModalInsert: {
      type: Boolean,
      default: false
    },
    todosde: {
      type: Boolean,
      default: true
    },
    busca: {
      type: String,
      default: ""
    }
  },
  data: () => ({
    items: null,
    itemRemove: null,
    itemDePara: {
      categoriaDePara: null,
      categoriaDeParaId: null,
      deStr: "",
      id: null,
      novaCategoriaDePara: null,
      paraStr: "",
      tenantId: null
    },
    empty: true,
    page: 1,
    totalRows: 1,
    size: 100,
    sort: {
      sortBy: "deStr",
      sortOrder: "ASC"
    },
    showModalDelete: false,
    showModalEditar: false,
    hasItems: false,
    idAtual: null,
    showModalInsertTmp: false,
    showModalDe: false
  }),
  watch: {
    page: function() {
      this.getData();
    },
    size: function() {
      this.getData();
    },
    sort: function() {
      this.getData();
    },
    filter: function() {
      this.getData();
    },
    CategoriaDeParaId: function(val) {
      this.itemDePara.categoriaDeParaId = val;
    },
    showModalInsert: function(val) {
      if (this.showModalInsertTmp != val) {
        this.showModalInsertTmp = val;
      }
    },
    showModalInsertTmp: function(val) {
      this.changeShowModal(val);
    },
    todosde: function() {
      this.getData();
    },
    busca: function() {
      this.getData();
    }
  },
  created() {
    this.$store.dispatch("alert/clear");
    if (this.$route.query.page) {
      this.page = this.$route.query.page;
    }
    this.getData();
  },
  computed: {},
  methods: {
    getData() {
      if (this.CategoriaDeParaId != -1) {
        api
          .get(
            `crud/DePara/${this.page}/${this.size}/${this.CategoriaDeParaId}`,
            {
              params: {
                filter: this.filter,
                include: this.include,
                sortBy: this.sort.sortBy,
                sortOrder: this.sort.sortOrder,
                listarTodosDe: this.todosde,
                busca: this.busca
              }
            }
          )
          .then(response => {
            this.items = response.data["data"];
            if (response.data["pagination"]) {
              this.page = response.data["pagination"]["pageNumber"];
              this.totalRows = response.data["pagination"]["totalRecords"];
            }
            if (
              response.data["data"] !== null &&
              response.data["data"].length > 0
            ) {
              this.hasItems = true;
            } else {
              this.hasItems = false;
            }
          });
      }
    },
    cancelRemove() {
      this.showModalDelete = false;
    },
    editarDePara(item) {
      this.itemDePara = JSON.parse(JSON.stringify(item));
      this.changeShowModal(true);
      this.idAtual = item.id;
    },
    confirmRemove() {
      if (this.itemRemove.id) {
        api.delete(`crud/DePara/${this.itemRemove.id}`).then(response => {
          if (response.data["status"].toLowerCase() == "success") {
            this.getData();
            this.showModalDelete = false;
          }
        });
      }
    },
    closeModal() {
      this.limpadepara();
      this.changeShowModal(false);
      this.idAtual = null;
    },
    changeShowModal(val) {
      this.$emit("update-showModalCadastro", val);
    },
    limpadepara() {
      this.itemDePara.id = null;
      this.itemDePara.categoriaDePara = null;
      this.itemDePara.deStr = "";
      this.itemDePara.paraStr = "";
      this.itemDePara.novaCategoriaDePara = null;
    },
    rotinaInsertUpdate() {
      this.limpadepara();
      this.closeModal();
      this.getData();
    },
    salvar() {
      // update
      this.itemDePara.deStr = this.itemDePara.deStr.trim();
      this.itemDePara.paraStr = this.itemDePara.paraStr.trim();

      if (this.idAtual) {
        api.put(`crud/DePara/`, this.itemDePara).then(response => {
          if (response.data["status"].toLowerCase() == "success") {
            this.rotinaInsertUpdate();
          } else {
            this.rotinaInsertUpdate();
          }
        });
      }
      // insert
      else {
        api.post(`crud/DePara/`, this.itemDePara).then(response => {
          if (response.data["status"].toLowerCase() == "success") {
            this.rotinaInsertUpdate();
          } else {
            this.rotinaInsertUpdate();
          }
        });
      }
    }
  }
};
</script>

<template>
  <div>
    <div class="table-sm table table-pd-sm">
      <table class="table b-table table table-hover">
        <thead class="thead-primary">
          <tr>
            <!-- <th class="columnheader" scope="col">
              #
              <i
                class="fas fa-sort-down ml-2"
                v-show="showSortDown(null, 'id', true)"
              />
              <i
                class="fas fa-sort-up ml-2"
                v-show="showSortUp(null, 'id', true)"
              />
              <i
                class="fas fa-sort ml-2"
                style="color: lightgray"
                v-show="showSortNone(null, 'id', true)"
              />
            </th> -->
            <th></th>
            <th
              class="columnheader"
              scope="col"
              @click="changeSort(field.sortName, field.name, field.sortable)"
              v-for="field in fields"
              :key="field.name + '.' + field.type"
            >
              {{ field.description }}
              <i
                class="fas fa-sort-down ml-2"
                v-show="
                  showSortDown(field.sortName, field.name, field.sortable)
                "
              />
              <i
                class="fas fa-sort-up ml-2"
                v-show="showSortUp(field.sortName, field.name, field.sortable)"
              />
              <i
                class="fas fa-sort ml-2"
                style="color: lightgray"
                v-show="
                  showSortNone(field.sortName, field.name, field.sortable)
                "
              />
            </th>
          </tr>
        </thead>
        <tbody class="selected-table">
          <tr v-for="item in items" :key="item.id">
            <template v-if="item.id !== null">
              <td width="10%">
                <div class="float-left">
                  <b-button
                    class="btn btn-sm btn-icon "
                    variant="primary"
                    v-on:click="editarDePara(item)"
                    ><i class="fe-more-horizontal"
                  /></b-button>

                  <b-button
                    variant="danger"
                    class="btn btn-sm btn-icon ml-1"
                    v-on:click="
                      showModalDelete = true;
                      itemRemove = item;
                    "
                    ><i class="fe-trash-2"
                  /></b-button>
                </div>
              </td>
              <td
                :style="{ margin: ' 0' }"
                v-for="field in fields"
                :key="field.name + '.' + field.type"
              >
                {{ item[field.name] | formatField(field.type) }}
              </td>
            </template>
            <template v-else>
              <td
                v-for="field in fields"
                :key="field.name + '.' + field.type"
                style="background-color:#f1f1f1;"
              >
                {{ item[field.name] | formatField(field.type) }}
              </td>
              <td style="background-color:#f1f1f1;">
                <div class="float-right">
                  <b-button
                    class="btn btn-sm btn-icon "
                    variant="primary"
                    v-on:click="editarDePara(item)"
                    ><i class="fe-plus"
                  /></b-button>
                </div>
              </td>
            </template>
          </tr>
        </tbody>
      </table>
      <div class="row" v-show="totalRows > 10">
        <div class="col-md-9 mt-1">
          <b-pagination
            v-model="page"
            pills
            :total-rows="totalRows"
            :per-page="size"
          />
        </div>
        <div class="col-md-3">
          <b-form-group
            id="size"
            label-cols-lg="7"
            label="Registros por página:"
          >
            <b-form-select v-model="size">
              <b-form-select-option value="10">10</b-form-select-option>
              <b-form-select-option value="20">20</b-form-select-option>
              <b-form-select-option value="50">50</b-form-select-option>
              <b-form-select-option value="100">100</b-form-select-option>
            </b-form-select>
          </b-form-group>
        </div>
      </div>
    </div>

    <b-modal
      @close="closeModal"
      @change="closeModal"
      v-model="showModalInsertTmp"
      :title="
        itemDePara.id != null ? 'Deseja realmente alterar?' : 'Cadastrar Depara'
      "
      centered
      hide-footer
    >
      <div class="button-list text-right">
        <b-form @submit.prevent="salvar">
          <b-form-group
            id="input-group-1"
            label="De"
            label-for="de"
            class="col-md-12 text-left"
          >
            <b-form-input
              id="deStr"
              type="text"
              :value="itemDePara.deStr"
              v-model="itemDePara.deStr"
              required
              autocomplete="off"
              :disabled="itemDePara.id != null"
            ></b-form-input>
          </b-form-group>

          <b-form-group
            id="input-group-1"
            label="Para"
            label-for="para"
            class="col-md-12 text-left"
          >
            <b-form-input
              id="paraStr"
              type="text"
              :value="itemDePara.paraStr"
              v-model="itemDePara.paraStr"
              autocomplete="off"
            ></b-form-input>
          </b-form-group>
          <b-button class="btn btn btn-icon" variant="light" @click="closeModal"
            >Cancelar</b-button
          >
          <b-button class="btn btn btn-icon" variant="primary" type="submit"
            >Salvar</b-button
          >
        </b-form>
      </div>
    </b-modal>

    <b-modal
      v-model="showModalDelete"
      title="Deseja realmente excluir?"
      centered
      hide-footer
      @hidden="cancelRemove()"
    >
      <div class="button-list text-right">
        <b-button
          class="btn btn btn-icon"
          variant="light"
          @click="showModalDelete = false"
          >Não</b-button
        >
        <b-button
          class="btn btn btn-icon"
          variant="primary"
          v-on:click="confirmRemove()"
          >Sim</b-button
        >
      </div>
    </b-modal>
  </div>
</template>
